import handleEventName from './event-name-handler';

/**
 * Функция, убирающая подписку
 */
function unsubscribe(evt, callback) {
  const self = this;
  const eventsArr = handleEventName(evt);

  eventsArr.forEach(evtName => {
    return self._selectEvent(evtName).remove(callback);
  });

  return;
}

export default unsubscribe;
